export const getMessagePercent = (
  executedPercent: number,
  strategyStatus: string,
): string =>
  executedPercent
    ? `${
        strategyStatus === 'SIMULATING' ? 'Simulação' : 'Ativação'
      } ${executedPercent}% concluída`
    : '';

export const getMessageTimeRemain = (
  messageTimeRemain: string,
  strategyStatus: string,
): string =>
  messageTimeRemain
    ? `Previsão de término da ${
        strategyStatus === 'SIMULATING' ? 'simulação' : 'ativação'
      }: ${messageTimeRemain}`
    : 'Atualizando...';

export const getMessageSupport = (activated: boolean): string =>
  activated ? 'Estratégia ativada com sucesso.' : 'Carregando...';
